import React from 'react';
import {Translation} from 'react-i18next';
import {Form, Select} from 'antd';

const SendStatusInput =({name, label, fieldKey=null, rules=null, disabled=false, ...props}) => {

  const options = [
    {
      value: 1,
      label: "call_call_status_queued",
    },
    {
      value: 2,
      label: "call_call_status_processing",
    },
    {
      value: 3,
      label: "call_call_status_complete",
    },
    {
      value: 4,
      label: "call_call_status_failed",
    },

  ];

  return (
    <Translation>{(t) => 
      <div className="form-group">
        <Form.Item
          name={name || 'priority'}
          fieldKey={fieldKey}
          label={label || t('call_priority')}
          rules={rules}
        >
          <Select disabled={disabled}>
            {options.map(x => <Select.Option key={x.value} value={x.value}>{t(x.label)}</Select.Option>)}
          </Select>
        </Form.Item>
      </div>
    }</Translation>
  );
}

export default SendStatusInput;
